import React        from 'react';
import { Link }     from 'react-router-dom';
import { getRoute } from 'pursuit/routes/routes'

export default function About() {
    return (
        <div role="home-about" className="grid-center-noGutter content-maxWidth">
            <div className="col-6_xs-0_sm-0_md-0 home-about--video">
                <div className="home-about--video-container" />
            </div>
            <div className="col-5_xs-11_sm-11_md-11 home-about--blurb">
                <h2>About Pursuit</h2>
                Pursuit Integrative Health is a newly opened health clinic servicing the <Link to={getRoute('contact')} className="link">Leslieville community</Link>. By providing collaborative care, across a number of disciplines, we offer a restorative experience tailored to your needs.
            </div>
        </div>
    );
}
